import React, { Component } from 'react';
import DovizKur from './../components/dovizkur';
import Bant from './../components/bant';
import http from "./../services/httpService";
import config from "./../config.json";

class DovizSayfa extends Component {
    state = {  
        avalues: [],
        dvalues: [],
    }

    componentDidMount(){
        this.setValues();
        this.interval = setInterval(() => this.setValues(), 2000);
        document.title = "Altınkaynak Şirketler Grubu - Canlı Döviz Bilgileri"
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    async setValues(){
        if(JSON.parse(localStorage.getItem('avalues')) !== null){
            this.setState({avalues:JSON.parse(localStorage.getItem('avalues')),dvalues:JSON.parse(localStorage.getItem('dvalues'))})
        }

        var {data : avalues} =  await http.get(config.restEndpoint + 'Gold');
        localStorage.setItem('avalues', JSON.stringify(avalues));
        var {data : dvalues} =  await http.get(config.restEndpoint + 'Currency');
        localStorage.setItem('dvalues', JSON.stringify(dvalues));

        if(avalues !== null & dvalues !== null)
            this.setState({avalues,dvalues})
    }

    render() { 
        return <div className="doviz-page">
            <Bant dvalues={this.state.dvalues} avalues={this.state.avalues}/>
            <div className="row">
                <div className="col-lg-6">
                    <div className="row">
                        <div className="col-lg-12">
                            <DovizKur main={false} group={1} showdescription={true} header={'Döviz'} values={this.state.dvalues}/>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="row">
                        <div className="col-lg-12">
                            <DovizKur main={false} group={4} showdescription={false} header={'Parite'} values={this.state.dvalues}/>
                        </div>
                    </div>
                </div>
          </div>
      </div>;
    }
}
 
export default DovizSayfa;